export function creationTime(ctime) {
    var timestamp = Date.parse(new Date());
    ctime = ctime.replace(/-/g, "/");//兼容ios
    var date = new Date(ctime);
    date = Date.parse(date);
    if (timestamp - date < 60 * 1000) {
        ctime = "刚刚";
    } else if (timestamp - date < 60 * 60 * 1000) {
        ctime = parseInt((timestamp - date) / (1000 * 60)) + "分钟前";
    } else if (timestamp - date < 24 * 60 * 60 * 1000) {
        ctime =
            parseInt((timestamp - date) / (60 * 60 * 1000)) + "小时前";
    } else if (timestamp - date < 365 * 24 * 60 * 60 * 1000) {
        ctime = ctime.slice(5);
        ctime = ctime.substring(0, ctime.length - 3);
    } else if (timestamp - date > 365 * 24 * 60 * 60 * 1000) {
        ctime = ctime.substring(0, ctime.length - 3);
    }
    ctime = ctime.replace(/\//g, '-')
    return ctime
}
export function cTime(ctime) {
    var timestamp = Date.parse(new Date());
    ctime = ctime.replace(/-/g, "/"); //兼容ios
    var date = new Date(ctime);
    date = Date.parse(date);
    if (timestamp - date < 60 * 1000) {
        ctime = "刚刚";
    } else if (timestamp - date < 60 * 60 * 1000) {
        ctime = parseInt((timestamp - date) / (1000 * 60)) + "分钟前";
    } else if (timestamp - date < 24 * 60 * 60 * 1000) {
        ctime =
            parseInt((timestamp - date) / (60 * 60 * 1000)) + "小时前";
    } else if (timestamp - date < 365 * 24 * 60 * 60 * 1000) {
        ctime = ctime.slice(5);
        ctime = ctime.substring(0, ctime.length - 3);
    } else if (timestamp - date > 365 * 24 * 60 * 60 * 1000) {
        ctime = ctime.substring(0, ctime.length - 3);
    }
    ctime = ctime.replace(/\//g, '.')
    return ctime
}
export function getNowFormatDate() {
    var date = new Date();
    var seperator1 = "-";
    var month = date.getMonth() + 1;
    var strDate = date.getDate();
    if (month >= 1 && month <= 9) {
        month = "0" + month;
    }
    if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
    }
    var currentdate =
        date.getFullYear() + seperator1 + month + seperator1 + strDate;
    return currentdate;
}
export function getFormatDate(date) {
    var seperator1 = "-";
    var month = date.getMonth() + 1;
    var strDate = date.getDate();
    if (month >= 1 && month <= 9) {
        month = "0" + month;
    }
    if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
    }
    var currentdate =
        date.getFullYear() + seperator1 + month + seperator1 + strDate;
    return currentdate;
}
export function getDay(day) {
    var today = new Date();
    var targetday_milliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day;
    today.setTime(targetday_milliseconds); //注意，这行是关键代码
    var tYear = today.getFullYear();
    var tMonth = today.getMonth();
    var tDate = today.getDate();
    tMonth =doHandleMonth(tMonth + 1);
    tDate =doHandleMonth(tDate);
    return tYear + "-" + tMonth + "-" + tDate;
  }
 function doHandleMonth(month) {
    var m = month;
    if (month.toString().length == 1) {
      m = "0" + month;
    }
    return m;
  }
